<template>
  <div class="beneficios">
    <div class="row">
      <div class="col-xs-12">
        <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
          <font-awesome-icon :icon="'arrow-left'"/>
          Voltar
        </button>
        <h2 class="page-header">Inserir Movimentos ODS</h2>
      </div>
    </div>
    <div class="row margem-bottom">
      <div class="col-xs-12">
        <upload @loadCSV="loadCSV" :separador="';'" />
      </div>
    </div>
    <div v-if="model.body.length" class="row">
      <div class="col-xs-12">
        <h3>Pré Visualização</h3>
      </div>
      <div class="col-xs-12">
        <data-table
          :dados="model.data"
          :fields="fields"
        >
          <template slot="columncustom" slot-scope="props">
            {{ `de ${props.rowData.INICIO || '-----'} à ${props.rowData.FIM || '-----'}` }}
          </template>
        </data-table>
      </div>
      <div class="col-xs-12 margem-bottom">
        <button @click="salvar()" class="btn btn-default" :disabled="carregando">
          <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
          <font-awesome-icon v-else :icon="'save'" />
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import upload from '@/components/common/CSVImport'
import DataTable from '@/components/common/NoApiTable'
import { request } from '@/request'

export default {
  components: { upload, DataTable },
  inject: ["showConfirm"],
  data () {
    return {
      carregando: false,
      model: {
        header: [],
        body: [],
        data: []
      },
      beneficios: [],
      fields: [
        {
          name: 'criado_em',
          title: 'Data',
        },
        {
          name: 'instituicao',
          title: 'Instituição'
        },
        {
          name: 'titulo',
          title: 'Titulo'
        },
        {
          name: 'data_inicio',
          title: 'Inicia em'
        },
        {
          name: 'hora_inicio',
          title: 'hora'
        },
        {
          name: 'data_encerramento',
          title: 'Encerramento'
        },        
        {
          name: 'acao_online',
          title: 'Online'
        }
      ],
    }
  },
  methods: {
    loadCSV (payload) {
      const checkFields = Object.keys(this.getDicionarioHeader())

      for (let index = 0; index < checkFields.length; index++) {
        const element = checkFields[index]
        if (!payload.header.includes(element)) {
          this.$toastr.e(`${element} é um campo obrigatório! Verifique a planilha.`)
          return
        }
      }

      this.model.header = payload.header
      this.model.body = payload.body

      this.model.data = this.convertCSVToJSON(this.model.body)    
    },
    getDicionarioHeader() {
      return {
        "Carimbo de data/hora": "criado_em",
        "Endereço de e-mail": "email",
        "INSTITUIÇÃO RESPONSÁVEL": "instituicao",
        "TÍTULO DA AÇÃO": "titulo",
        "DESCRIÇÃO DA AÇÃO (MÁXIMO 300 CARACTERES)": "descricao",
        "LOCAL DA AÇÃO": "local",
        "DATA DE INÍCIO": "data_inicio",
        "HORA DE INÍCIO": "hora_inicio",
        "DATA DE ENCERRAMENTO": "data_encerramento",
        "AÇÃO SERÁ ONLINE?": "acao_online",
        "LINKS OU INSTRUÇÕES DE COMO PARTICIPAR OU SE INSCREVER NA AÇÃO (SE APLICÁVEL)": "links_instrucao",
        "QUE TIPO DE AÇÃO?": "tipo_acao",
        "ENVIE FOTOS DA AÇÃO": "link_fotos",
        "QUAL(IS) BANDEIRA(S) ODS É(SÃO) O FOCO DE SUA AÇÃO?": "bandeiras",
        "NÚMERO ESPERADO DE PARTICIPANTES (PODE ESTIMAR)": "total_participantes_esperado"
      }
    },
    convertCSVToJSON(body) {
      return  body.map(item => this.convertItem(item))
    },
    convertItem(item) {
      return {
        "criado_em": new Date(item["Carimbo de data/hora"]).toLocaleString().replace(', ', ' '),
        "email": item["Endereço de e-mail"],
        "instituicao": item["INSTITUIÇÃO RESPONSÁVEL"],
        "titulo": item["TÍTULO DA AÇÃO"],
        "descricao": item["DESCRIÇÃO DA AÇÃO (MÁXIMO 300 CARACTERES)"],
        "local": item["LOCAL DA AÇÃO"],
        "data_inicio": item["DATA DE INÍCIO"],
        "hora_inicio": item["HORA DE INÍCIO"],
        "data_encerramento": item["DATA DE ENCERRAMENTO"],
        "acao_online": item["AÇÃO SERÁ ONLINE?"],
        "links_instrucao": item["LINKS OU INSTRUÇÕES DE COMO PARTICIPAR OU SE INSCREVER NA AÇÃO (SE APLICÁVEL)"],
        "tipo_acao": item["QUE TIPO DE AÇÃO?"],
        "link_fotos": item["ENVIE FOTOS DA AÇÃO"],
        "bandeiras": item["QUAL(IS) BANDEIRA(S) ODS É(SÃO) O FOCO DE SUA AÇÃO?"],
        "total_participantes_esperado": item["NÚMERO ESPERADO DE PARTICIPANTES (PODE ESTIMAR)"]
      }
    },
    salvar () {
      const me = this
      const { data } = this.model
      var config = {
        title: 'Deseja Salvar?',
        question: true,
        yes: () => {
          me.carregando = !me.carregando
          request.post(
            'ods/movimentos',
             { data }
          ).then(() => me.$router.back())
          .catch(error => {
            console.log(error)
          }).then(() => {
            me.carregando = !me.carregando
          })
        }
      }
      this.showConfirm(
        'Confirmar a inserção dos itens?',
        config
      )
    }
  }
}
</script>

<style>
.btn-voltar {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/admin/ods/movimentos/Import.vue